import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Constanst } from 'src/app/core/constants/constans.component';
import { ApiCallService } from 'src/app/core/services/api-call.service';
import { HelperClassService } from 'src/app/core/services/clase-utilidades.services';

@Component({
  selector: 'app-nuevo-usuario',
  templateUrl: './nuevo-usuario.component.html',
  styleUrls: ['./nuevo-usuario.component.css']
})
export class NuevoUsuarioComponent implements OnInit {

  private method: string;
  private route: string;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  date: Date = new Date();
  todayDate: Date = new Date((this.date.getFullYear() - 1), 0, 1);
  messageDialog: string = '';
  resultDialog: string = '';
  startDateFfin: Date = new Date();
  disabledFfin: boolean = true;

  constructor(
    private router: Router,
    private helperClassService: HelperClassService,
    public apiCallService: ApiCallService,
    private dateAdapter: DateAdapter<Date>
  ) { this.dateAdapter.setLocale(Constanst.LOCALE_VE); }

  ngOnInit() {
  }

  registerForm = new FormGroup({
    usuario: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
    nombreUsuario: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]),
    apellidoUsuario: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(20)]),
    correoUsuario: new FormControl('', [Validators.required, Validators.pattern(Constanst.REGEXP_EMAIL)]),
    perfilUsuario: new FormControl('', [Validators.required]),
    numTelefonoUser: new FormControl('', [Validators.minLength(10)]),
    nombreEmpresa: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(50)]),
    numRif: new FormControl('', [Validators.required, Validators.pattern(Constanst.REGEXP_RIF)]),
    numTelefonoEmpresa: new FormControl('', [Validators.required, Validators.minLength(10)]),
    ciudadEmpresa: new FormControl('', [Validators.required, Validators.minLength(4), Validators.maxLength(30)]),
    correoEmpresa: new FormControl('', [Validators.pattern(Constanst.REGEXP_EMAIL)]),
    numSerial: new FormControl('', [Validators.required, Validators.minLength(14), Validators.maxLength(20)]),
    numLicencias: new FormControl('', [Validators.required, Validators.pattern(Constanst.REGEXP_NUMBERS)]),
    fechaInicioLicencia: new FormControl('', [Validators.required]),
    fechaFinLicencia: new FormControl('', [Validators.required]),
  });

  onSubmit(): void {
    if (this.registerForm.invalid) {
      return;
    } else {
      return this.confirm();
    }
  }

  confirm() {
    const dialog = this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_CONFIRM_USER, true, true, false, Constanst.DIALOG_ACTIONBTCANCEL, Constanst.DIALOG_ACTIONBTACCEPT, '', Constanst.DIALOG_RESULT_INFO);
    dialog.afterClosed().subscribe((result: string) => {
      if (result === Constanst.DIALOG_RESULT_ACTION) {
        this.route = '/register';
        this.method = 'POST';

        let data = {
          userEntity: {
            username: this.registerForm.controls['usuario'].value,
            password: Constanst.GENERIC_PASSWORD,
            fullName: this.registerForm.controls['nombreUsuario'].value + ' ' +
                      this.registerForm.controls['apellidoUsuario'].value,
            email: this.registerForm.controls['correoUsuario'].value,
            phoneNumber: this.registerForm.controls['numTelefonoUser'].value,
            profileEntity: {
                idProfile: this.registerForm.controls['perfilUsuario'].value
            }
          },
          companyEntity: {
            rif: this.registerForm.controls['numRif'].value,
              companyName: this.registerForm.controls['nombreEmpresa'].value,
            email: this.registerForm.controls['correoEmpresa'].value,
              legalAgent: this.registerForm.controls['perfilUsuario'].value,
              fiscalAddress: this.registerForm.controls['ciudadEmpresa'].value,
            phone: this.registerForm.controls['numTelefonoEmpresa'].value,
            licenseNumber: this.registerForm.controls['numLicencias'].value
          },
          licenseEntity: {
            serialLicense: this.registerForm.controls['numSerial'].value,
            initDate: this.registerForm.controls['fechaInicioLicencia'].value,
            endDate: this.registerForm.controls['fechaFinLicencia'].value
          }
        }
        //console.log(data);
        this.apiCallService.call$(data, this.route, this.method, true, '', true)
          .pipe(takeUntil(this.destroy$)).subscribe(responseRegister => {
            if (responseRegister.status === Constanst.RESPONSE_STATUS_SUCCESS) {
              this.messageDialog = Constanst.MSG_USER_REGISTERED;
              this.resultDialog = Constanst.DIALOG_RESULT_SUCCESS;

                this.route = '/registerCompanyBudget';
                this.method = 'POST';
              let idUser = responseRegister.data;

                let dataCompanyBudget = {
                  companyBudgetEntity: {
                    rif: data.companyEntity.rif,
                    companyName: data.companyEntity.companyName,
                    email: data.companyEntity.email,
                    fiscalAddress: data.companyEntity.fiscalAddress,
                    phone: data.companyEntity.phone,
                    legalAgent: data.userEntity.fullName,
                    nit: '',
                    userEntity: {
                      idUser: Number(idUser)
                    }
                  }
                }

                this.apiCallService.call$(dataCompanyBudget, this.route, this.method, true, '', true)
                  .pipe(takeUntil(this.destroy$)).subscribe(registerCompany => {
                    if (registerCompany.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                      this.messageDialog = Constanst.MSG_USER_REGISTERED;
                      this.resultDialog = Constanst.DIALOG_RESULT_SUCCESS;
                    } else {
                      this.messageDialog = Constanst.MSG_USER_REGISTERED;
                      this.resultDialog = Constanst.DIALOG_RESULT_SUCCESS;
                    }
                  });
            } else {
              switch (responseRegister.data.code) {
                case 'MSG-005': {
                  this.messageDialog = Constanst.MSG_005;
                  break;
                } default: {
                  this.messageDialog = Constanst.MSG_GENERIC_ERROR;
                }
              }
              this.resultDialog = Constanst.DIALOG_RESULT_ERROR;
            }

            this.apiCallService.hideSpinner();
            const dialog = this.helperClassService.openDialogGeneric('25rem', true, this.messageDialog, false, true, false, '', '', '', this.resultDialog);
            dialog.afterClosed().subscribe(() => {
              if (responseRegister.status === Constanst.RESPONSE_STATUS_SUCCESS) {
                this.router.navigate(['menu']);
              }
            });
          },
          error => {
            //console.log('Falla al registrar al usuario ', error)
            this.apiCallService.hideSpinner();
            this.helperClassService.openDialogGeneric('25rem', true, Constanst.MSG_GENERIC_ERROR, false, true, false, '', '', '', Constanst.DIALOG_RESULT_ERROR);
            this.router.navigate(['menu']);
          }
        );
      } else {
        dialog.close(false);
      }
    });
  }

  navigateMenu(tag: string) {
    this.router.navigate(['/' + tag]);
  }

  onDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (event.value != null && event.value > this.date) {
      this.startDateFfin = new Date(event.value.getFullYear(), event.value.getMonth(), (event.value.getDate() + 1));
    } else {
      this.startDateFfin = new Date();
    }
    this.disabledFfin = false;
  }

}
